import React from 'react';
import { Card, Row, Col } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const workHoursData = [
    { date: 'Oct 30', hours: 10 },
    { date: 'Oct 31', hours: 8 },
    { date: 'Nov 01', hours: 12 },
    { date: 'Nov 02', hours: 9 },
    { date: 'Nov 03', hours: 11 },
    { date: 'Nov 04', hours: 6 },
    { date: 'Nov 05', hours: 1 },
];

const breakDurationData = [
    { month: 'Jan', duration: 4 },
    { month: 'Feb', duration: 8 },
    { month: 'Mar', duration: 6 },
    { month: 'Apr', duration: 5 },
    { month: 'May', duration: 7 },
    { month: 'Jun', duration: 6 },
    { month: 'Jul', duration: 8 },
];

const WorkStatsChart: React.FC = () => {
    return (
        <div style={{ padding: '20px' }}>
            <Row gutter={[16, 16]}>
                {/* Employees' Effective Work Hours Chart */}
                <Col xs={24} md={12}>
                    <Card title="Employees' Effective Work Hours">
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={workHoursData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis label={{ value: 'Work Hours', angle: -90, position: 'insideLeft' }} />
                                <Tooltip />
                                <Line type="monotone" dataKey="hours" stroke="#1890ff" strokeWidth={2} fill="url(#colorUv)" />
                            </LineChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>

                {/* Break Taken by Employees Chart */}
                <Col xs={24} md={12}>
                    <Card title="Break Taken by Employees">
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={breakDurationData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis label={{ value: 'Break Duration (Minutes)', angle: -90, position: 'insideLeft' }} />
                                <Tooltip />
                                <Line type="monotone" dataKey="duration" stroke="#722ed1" strokeWidth={2} fill="url(#colorUv)" />
                            </LineChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default WorkStatsChart;
